import React from 'react';

interface ReportOutageIconProps extends React.SVGProps<SVGSVGElement> {
  size?: number | string;
  color?: string;
  variant?: 'filled' | 'outlined';
}

const ReportOutageIcon: React.FC<ReportOutageIconProps> = ({
  size = 26,
  color = '#0098D9',
  variant = 'outlined',
  ...props
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {variant === 'outlined' && (
        <path
          d="M12.682 20.4966L17.3127 11.5803H13.518V5.6353L8.69067 14.589H12.682V20.4966ZM13.0023 25.7513C11.2594 25.7513 9.61867 25.4189 8.08 24.754C6.54134 24.0891 5.19811 23.1831 4.05034 22.036C2.90278 20.8886 1.99634 19.546 1.331 18.008C0.665891 16.47 0.333336 14.8296 0.333336 13.087C0.333336 11.335 0.66578 9.68819 1.33067 8.14664C1.99556 6.60508 2.90156 5.26419 4.04867 4.12397C5.196 2.98375 6.53867 2.08097 8.07667 1.41564C9.61467 0.750524 11.255 0.417969 12.9977 0.417969C14.7497 0.417969 16.3964 0.750413 17.938 1.4153C19.4796 2.08019 20.8204 2.98252 21.9607 4.1223C23.1009 5.26208 24.0037 6.60241 24.669 8.1433C25.3341 9.68419 25.6667 11.3305 25.6667 13.0823C25.6667 14.8252 25.3342 16.466 24.6693 18.0046C24.0044 19.5433 23.1021 20.8865 21.9623 22.0343C20.8226 23.1819 19.4822 24.0883 17.9413 24.7536C16.4004 25.4187 14.7541 25.7513 13.0023 25.7513ZM13 24.076C16.062 24.076 18.6594 23.0073 20.7923 20.87C22.925 18.7326 23.9913 16.1375 23.9913 13.0846C23.9913 10.0226 22.925 7.42519 20.7923 5.2923C18.6594 3.15963 16.062 2.0933 13 2.0933C9.94711 2.0933 7.352 3.15963 5.21467 5.2923C3.07734 7.42519 2.00867 10.0226 2.00867 13.0846C2.00867 16.1375 3.07734 18.7326 5.21467 20.87C7.352 23.0073 9.94711 24.076 13 24.076Z"
          fill={color}
        />
      )}

      {variant === 'filled' && (
        <path
          d="M13.9956 0C15.9307 0 17.7573 0.367598 19.475 1.1033C21.1925 1.83904 22.6314 2.83436 23.791 4.08928C24.9506 5.34419 25.9471 6.83602 26.7809 8.56473C27.6148 10.2932 28.0318 12.1189 28.0318 14.0426C28.0318 15.964 27.6149 17.7836 26.7812 19.5006C25.9476 21.2174 24.9522 22.6582 23.7945 23.8231C22.6366 24.9883 21.1955 25.9863 19.4793 26.8185C17.763 27.6515 15.9436 28.0685 14.0214 28.0685C12.1001 28.0685 10.2805 27.6516 8.56355 26.8179C6.84675 25.9844 5.40434 24.9897 4.23661 23.8337C3.06903 22.678 2.07086 21.2366 1.2378 19.5201C0.404446 17.8035 -0.00975624 15.9849 0.00030606 14.0636C0.0103986 12.1399 0.431099 10.3141 1.26006 8.5853C2.08909 6.85676 3.08202 5.36358 4.2377 4.10437C5.39356 2.84477 6.83543 1.84859 8.56339 1.11576C10.292 0.383249 12.1169 -0.0103835 13.9956 0ZM8.1554 13.6915L13.3476 15.7844L10.554 22.9463L20.1883 14.3605L15.1917 12.3764L18.0884 5.05652L8.1554 13.6915Z"
          fill={color}
        />
      )}
    </svg>
  );
};

export default ReportOutageIcon;
